import { render, staticRenderFns } from "./UpdateIdentifiers.vue?vue&type=template&id=7722cc9d"
import script from "./UpdateIdentifiers.vue?vue&type=script&lang=ts"
export * from "./UpdateIdentifiers.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports